var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserNutriDiet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_89_532)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.8995 4.85555C21.2553 2.21141 17.7395 0.755081 14 0.755081C10.2605 0.755081 6.74472 2.21135 4.10047 4.85555C1.45633 7.4998 0 11.0156 0 14.7551C0 18.4946 1.45627 22.0104 4.10047 24.6546C6.74472 27.2988 10.2605 28.7551 14 28.7551C17.7395 28.7551 21.2553 27.2988 23.8995 24.6546C26.5437 22.0104 28 18.4946 28 14.7551C28 11.0156 26.5437 7.4998 23.8995 4.85555ZM6.07606 24.2323C6.53838 20.2546 9.95827 17.1836 14 17.1836C16.1306 17.1836 18.1343 18.0137 19.6413 19.5206C20.9145 20.794 21.7176 22.4566 21.9241 24.232C19.7772 26.0301 17.013 27.1145 14 27.1145C10.987 27.1145 8.22298 26.0303 6.07606 24.2323ZM14 15.4937C11.6555 15.4937 9.74783 13.5861 9.74783 11.2416C9.74783 8.8969 11.6555 6.98946 14 6.98946C16.3445 6.98946 18.2522 8.8969 18.2522 11.2416C18.2522 13.5861 16.3445 15.4938 14 15.4938V15.4937ZM23.3362 22.8452C22.9147 21.1477 22.0383 19.5972 20.8013 18.3606C19.793 17.3523 18.6001 16.5959 17.2992 16.1218C18.8631 15.0612 19.8928 13.2693 19.8928 11.2416C19.8928 7.99242 17.2492 5.34883 14 5.34883C10.7508 5.34883 8.1072 7.99242 8.1072 11.2416C8.1072 13.2704 9.13773 15.0629 10.7029 16.1234C9.506 16.5595 8.39841 17.234 7.44543 18.1218C6.06539 19.4069 5.1071 21.0456 4.66277 22.8439C2.78097 20.6746 1.64062 17.8456 1.64062 14.7551C1.64062 7.94009 7.18501 2.39571 14 2.39571C20.815 2.39571 26.3594 7.94009 26.3594 14.7551C26.3594 17.8462 25.2186 20.6759 23.3362 22.8452Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_89_532"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(0 0.755081)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserNutriDiet);
export default __webpack_public_path__ + "static/media/user_nutri_diet.e99146eb3e305f5c462a0697b2a32e64.svg";
export { ForwardRef as ReactComponent };